"use client";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import Close from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content/Close";

type Props = {
  onClose: () => void;
  hiddenCloseBtn?: boolean;
  className?: string;
  testId?: string;
};

const Content: FC<Props> = ({
  onClose,
  hiddenCloseBtn,
  children,
  className,
  testId,
}) => (
  <div
    data-testid={testId}
    className={classNames(
      "relative grid w-[stretch] gap-4 rounded-lg bg-white px-8 pb-8 text-center shadow-xl md:w-80",
      className,
    )}
  >
    {!hiddenCloseBtn && <Close onClose={onClose} />}
    {children}
  </div>
);

export default Content;
